import { ethers } from "ethers";
import Base721 from "./Base721";
import config from "../config";
import bearsabi from "../abis/bears.json";

class BearsContract extends Base721 {
    constructor(signer: ethers.Signer | ethers.providers.Provider) {
        super(config.bearsAddress, bearsabi, signer);
    }

    async exists(tokenId: number): Promise<boolean> {
        try {
            return await this.contract.exists(tokenId);
        } catch {
            // Fallback: try ownerOf - if it succeeds, token exists
            try {
                await this.contract.ownerOf(tokenId);
                return true;
            } catch {
                return false;
            }
        }
    }
}

export default BearsContract;